import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { z } from 'zod/v3';

import { sortingDirectionSchema } from 'features/procurement/schema';

import { clawbackListLayoutRoute } from '..';
import { ClawbackRequestSortingCriteria, ClawbackRequestsRequestParams } from '../api-types';

const clawbackSortingCriteriaSchema = z.custom<ClawbackRequestSortingCriteria>(
  (value): value is ClawbackRequestSortingCriteria =>
    value === 'DUE_DATE' || value === 'REQUESTED_AMOUNT',
);

export const clawbackListRoute = createRoute({
  getParentRoute: () => clawbackListLayoutRoute,
  path: '/',
  component: lazyRouteComponent(() => import('./ClawbackListView')),
  validateSearch: z.object({
    q: z.string().optional(),
    statuses: z.custom<ClawbackRequestsRequestParams['statuses']>().optional(),
    types: z.custom<ClawbackRequestsRequestParams['clawbackTypes']>().optional(),
    vendors: z.array(z.string()).optional(),
    warehouses: z.array(z.string()).optional(),
    sortBy: clawbackSortingCriteriaSchema.optional(),
    sortingType: sortingDirectionSchema.optional(),
    page: z.coerce.number().optional(),
    pageSize: z.coerce.number().optional(),
  }).parse,
});
